export default __webpack_public_path__ + "static/media/5279112_camera_instagram_social media_instagram logo_icon.44073b03.svg";